module.exports = __webpack_public_path__ + "img/big-owl_5.7e161d95.png";